export default "__VITE_ASSET__Cz1spiLo__"